/* eslint-disable */
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { AxiosError } from "axios";
import { showNotification } from "@mantine/notifications";
import { customAxios } from "lib/axios";

export type AdminEditLeavePayload = {
  leaveId: string;
  fromDate: string;
  toDate: string;
  leaveType: string;
  reason?: string;
};

export type AdminEditLeaveResponse = {
  success: boolean;
  message?: string;
  data?: any;
};

const adminEditLeave = async (
  leaveId: string,
  body: Omit<AdminEditLeavePayload, "leaveId">
): Promise<AdminEditLeaveResponse> => {
  const res = await customAxios.put<AdminEditLeaveResponse>(
    `/leaves/admin-edit-leave/${leaveId}`,
    body
  );
  return res.data;
};

export const useAdminEditLeave = () => {
  const queryClient = useQueryClient();

  return useMutation<AdminEditLeaveResponse, AxiosError, AdminEditLeavePayload>(
    (payload) =>
      adminEditLeave(payload.leaveId, {
        fromDate: payload.fromDate,
        toDate: payload.toDate,
        leaveType: payload.leaveType,
        reason: payload.reason,
      }),
    {
      onSuccess: (data) => {
        showNotification({
          title: "Leave Updated",
          message: data?.message || "Leave has been updated successfully.",
          color: "green",
        });
        queryClient.invalidateQueries({
          predicate: (query) => query.queryKey?.[0] === "leaveRequestsAdmin",
        });
      },
      onError: (error: AxiosError) => {
        showNotification({
          title: "Update Failed",
          message:
            (error?.response?.data as any)?.message ||
            "Failed to update leave. Please try again.",
          color: "red",
        });
      },
      retry: 1,
    }
  );
};
